// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__1nczn","colMin":"styles_colMin__1G9ED","colCheckbox":"styles_colCheckbox__3KuBr"};